import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { animationClass } from "features/data-management/workspace/constants"
import { useState } from "react"

type ViewModeProps = { Icon: Icons.IconComponent; isSelected: boolean; onClick: () => void }

export const ViewMode = ({ Icon, isSelected, onClick }: ViewModeProps) => {
    const [isHovering, setIsHovering] = useState(false)

    return (
        <div
            className={classNames(
                animationClass,
                "flex justify-center items-center rounded-md w-6 h-6 cursor-pointer",
                {
                    "text-gray-300": !isSelected && !isHovering,
                    "text-gray-0": isSelected || isHovering,
                    "bg-gray-700": isSelected,
                }
            )}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            onClick={onClick}
        >
            <Icons.SmallIcon Icon={Icon} />
        </div>
    )
}

export const LargeViewMode = ({ Icon, isSelected, onClick }: ViewModeProps) => {
    const [isHovering, setIsHovering] = useState(false)

    return (
        <div
            className={classNames(
                animationClass,
                "flex justify-center items-center rounded-md w-8 h-8 cursor-pointer",
                {
                    "text-gray-500": !isSelected && !isHovering,
                    "text-gray-0": isSelected || isHovering,
                    "bg-gray-700": isSelected,
                }
            )}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            onClick={onClick}
        >
            <Icons.Icon Icon={Icon} />
        </div>
    )
}
